import type { VotingPeriod } from "@book-club/shared";
import { useQuery } from "@tanstack/react-query";
import votingService from "@/features/voting/services/votingService";
import DURATIONS from "@/shared/constants/durations";
import { votingQueryKeys } from "./votingQueryKeys";

/**
 * Fetches all open voting periods from Firestore
 * Uses 1 minute staleTime for caching (voting periods may change frequently)
 * Polls every 10 minutes for real-time vote count updates
 * @returns Query result with open voting periods
 */
export function useVotingPeriods() {
    return useQuery<VotingPeriod[], Error>({
        gcTime: DURATIONS.ONE_HOUR,
        queryFn: () => votingService.getVotingPeriods(),
        queryKey: votingQueryKeys.periods(),
        refetchInterval: DURATIONS.TEN_MINUTES, // Poll every 10 minutes
        refetchIntervalInBackground: false, // Only poll when tab is active
        staleTime: DURATIONS.ONE_MINUTE,
    });
}
